"use client";

import { useCallback } from "react";
import { LoginForm, type UsersLoginSuccess } from "../index";

export interface LoginPageProps {
  /**
   * Portal title (e.g., "Admin Portal", "Manager Portal", "Consumer Portal")
   */
  title: string;
  /**
   * Subtitle description
   */
  subtitle: string;
  /**
   * Form title inside the card
   */
  formTitle: string;
  /**
   * Form description
   */
  formDescription: string;
  /**
   * Initial email for development
   */
  initialEmail: string;
  /**
   * Initial password for development
   */
  initialPassword: string;
  /**
   * Callback when login succeeds
   */
  onLoginSuccess: (session: UsersLoginSuccess) => void;
  /**
   * Show development credentials helper
   */
  showCredentialsHelper?: boolean;
  /**
   * Additional footer text
   */
  footerText?: string;
}

export function LoginPage({
  title,
  subtitle,
  formTitle,
  formDescription,
  initialEmail,
  initialPassword,
  onLoginSuccess,
  showCredentialsHelper = true,
  footerText,
}: LoginPageProps): React.ReactElement {
  const handleLoginSuccess = useCallback(
    (session: UsersLoginSuccess) => {
      onLoginSuccess(session);
    },
    [onLoginSuccess],
  );

  return (
    <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 p-6">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-white mb-2">{title}</h1>
          <p className="text-gray-300">{subtitle}</p>
        </div>
        
        <div className="bg-white/10 backdrop-blur-lg rounded-lg shadow-2xl p-8 border border-white/20">
          <div className="mb-6">
            <h2 className="text-xl font-semibold text-white mb-2">{formTitle}</h2>
            <p className="text-sm text-gray-300">{formDescription}</p>
          </div>
          
          <LoginForm
            title=""
            description=""
            onLoginSuccess={handleLoginSuccess}
            showCredentialsHelper={showCredentialsHelper}
            initialEmail={initialEmail}
            initialPassword={initialPassword}
          />
        </div>
        
        {footerText && (
          <div className="mt-6 text-center text-sm text-gray-400">
            <p>{footerText}</p>
          </div>
        )}
        
        {showCredentialsHelper && (
          <div className="mt-6 bg-white/5 rounded-lg p-4 border border-white/10">
            <p className="text-xs text-gray-400 text-center">
              Development Credentials
            </p>
            <p className="text-sm text-gray-300 text-center font-mono mt-1">
              {initialEmail}
            </p>
            <p className="text-xs text-gray-400 text-center mt-1">
              Password: P@ssw0rd!123
            </p>
          </div>
        )}
      </div>
    </main>
  );
}

